import React, { createContext, useCallback, useContext, useMemo, useState } from "react"
import { t as translate, setLanguage as setCatalogLanguage } from "./translates"
import { LANGUAGES } from "./mockData"

const LANG_STORAGE_KEY = "voxdoc.lang"

const readStoredLanguage = () => {
  try {
    const stored = (localStorage.getItem(LANG_STORAGE_KEY) || "").toLowerCase()
    return LANGUAGES.some((l) => l.code === stored && l.enabled) ? stored : "en"
  } catch {
    return "en"
  }
}

const LanguageContext = createContext(null)

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => setCatalogLanguage(readStoredLanguage()))

  // A kiválasztott nyelv a localStorage-ba kerül (nagybetűs kód: EN/HU/DE/FR); a váltás azonnal újrarenderel minden t()-t használó komponenst
  const setLanguage = useCallback((next) => {
    const applied = setCatalogLanguage(String(next).toLowerCase())
    try { localStorage.setItem(LANG_STORAGE_KEY, applied.toUpperCase()) } catch { /* localStorage nem elérhető */ }
    setLanguageState(applied)
  }, [])

  // A t új referenciát kap nyelvváltáskor, így a memoizált komponensek is frissülnek
  const t = useMemo(() => (key, fallbackOrVars, maybeFallback) => translate(key, fallbackOrVars, maybeFallback), [language]) // eslint-disable-line react-hooks/exhaustive-deps

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t])
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}

export const useLanguage = () => useContext(LanguageContext)

export const useT = () => useContext(LanguageContext).t
